import React from "react";
import { graphql, useFragment } from "react-relay";
import { TeamScheduleListItemWeeklyRangeComponent } from "../Team/TeamHomeNavigator/TeamScheduleListItem/TeamScheduleListItemScheduleRange/TeamScheduleListItemWeeklyRange";
import { TeamScheduleWeeklyWeekdayIndicator_RoutineScheduleWeekly$key } from "./__generated__/TeamScheduleWeeklyWeekdayIndicator_RoutineScheduleWeekly.graphql";

export function TeamScheduleWeeklyWeekdayIndicator(props: {
  schedule: TeamScheduleWeeklyWeekdayIndicator_RoutineScheduleWeekly$key;
}) {
  const schedule = useFragment(
    graphql`
      fragment TeamScheduleWeeklyWeekdayIndicator_RoutineScheduleWeekly on RoutineScheduleWeekly {
        startWeekday
        endWeekday
      }
    `,
    props.schedule
  );
  return (
    <TeamScheduleListItemWeeklyRangeComponent
      endWeekday={schedule.endWeekday}
      startWeekday={schedule.startWeekday}
    />
  );
}
